import anchor from './anchor.module.scss'
import primary from './primary.module.scss'
import secondary from './secondary.module.scss'

interface Preset {
    medium?: string
    small?: string
    playing?: string
    complete?: string
    button?: string
}

export const PRESETS = {
    anchor: anchor as Preset,
    primary: primary as Preset,
    secondary: secondary as Preset,
    plain: {} as Preset,
}
